<div>
  <input
    [disabled]="!active()"
    type="radio"
    [name]="selectionGroupId()"
    (click)="toggleSelection()"
    [checked]="checked()"
  />
</div>
